import { useAppSelector } from '@shared/store';
import useIsTimePassed from '@shared/hooks/useIsTimePassed';
import { MILLISECONDS_BEFORE_JOURNEY_REAL_TIME_DATA_IS_TOO_OLD } from '@shared/constants';
import { useContext, useMemo } from 'react';
import { BoardContext } from '@shared/contexts/BoardContext';
import createVehicle from '../utils/createVehicle';

export default function useVehicle() {
  const boardContext = useContext(BoardContext);
  const realTimeJourney = useAppSelector(
    (state) => state.journeys[boardContext.id]?.resource,
  );
  const vehicleState = useAppSelector((state) => state.vehicle);
  const serverSentEventsLastAliveEventTime = useAppSelector(
    (state) => state.serverSentEvents.lastAliveEventTime,
  );
  const realTimeHasExpired = useIsTimePassed(
    serverSentEventsLastAliveEventTime,
    MILLISECONDS_BEFORE_JOURNEY_REAL_TIME_DATA_IS_TOO_OLD,
  );
  const journeyErrorStartTime = useAppSelector(
    (state) => state.journeys[boardContext.id]?.errorStartTime,
  );
  const hasJourneyError = useIsTimePassed(journeyErrorStartTime);
  const hasExpiredVehicleState = useIsTimePassed(vehicleState.expires);

  const vehicle = useMemo(() => {
    return createVehicle(
      vehicleState,
      realTimeJourney,
      realTimeHasExpired || hasJourneyError,
      hasExpiredVehicleState,
    );
  }, [
    vehicleState,
    realTimeJourney,
    realTimeHasExpired,
    hasJourneyError,
    hasExpiredVehicleState,
  ]);

  return vehicle;
}
